import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import {  faEnvelope } from "@fortawesome/free-solid-svg-icons";

import './Footer.css';

const Footer = () => {
    return (
        <div id='footer'>
            <Container>
                <Row>
                    <Col lg={6} md={6} sm={12}>
                        <div className='subFooter-left'>
                            <h2>PORTFOLIO <span>of Dilruba Borna</span></h2>
                            <h6>Front end developer</h6>
                            <h6>Providing reliable Services since 2019</h6>
                        </div>
                    </Col>

                    <Col lg={6} md={6} sm={12}>
                        <div className='subFooter-right'>
                            <div className='subFooter'>
                               <h4>SOCIAL</h4> 
                            </div>
                            
                        <div className='d-flex mt-4'>                          
                            <div className="text-sm-middle footer-icon">           
                                <a href="https://www.linkedin.com/in/dilruba-jannat-borna-09147b216/">
                                <FontAwesomeIcon icon={faLinkedinIn}  className='linkedin'/>
                                </a>          
                            </div>

                            <div className="text-sm-middle footer-icon mx-3">
                                <a href="https://github.com/JannatBorna" >
                                <FontAwesomeIcon icon={faGithub} className='github'/>
                                </a>
                            </div>

                            <div className="text-sm-middle footer-icon">
                                <a href="mailto:boena.dilruba@gmail.com">
                                <FontAwesomeIcon icon={faEnvelope} className='mail'/>
                                </a>
                            </div> 

                        </div>               
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Footer;